module.exports = __webpack_public_path__ + "static/media/montserrat-v15-latin-regular.8102c483.woff";